<template>
  <div class="applyNoatr">
    <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
    >
      <p class="notarization-desc-titile">
        （公证书仅限用于民事诉讼或仲裁）
      </p>
      <div class="notarization-title">

        <h3> 您正在将
          <span v-text="checkExecutionInfo.count"></span> 个证据文件统一申请公证
        </h3>
      </div>
      <el-form-item label="申请公证名称：" prop="name">
        <el-input v-model="ruleForm.name" placeholder="请输入要公证合同名称"></el-input>
      </el-form-item>
      <el-form-item label="包含证据文件：">
        <el-input :disabled="true" v-model="checkExecutionInfo.count"></el-input>
      </el-form-item>
      <!-- <el-form-item label="公证处所在地：" prop="notarization">
        <el-select v-model="ruleForm.notarization" placeholder="请选择" @change="linkageFn" >
           <el-option v-for="(item,index) in NotaryUser" :key="index" :label="item.province" :value="item.notaryCode"></el-option>
         
        </el-select>
      </el-form-item>
      <el-form-item label="公证处：" prop="location">
        <el-select v-model="ruleForm.location" placeholder="请选择">
          <el-option v-for="item in listData" :key="item.name" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="领取人：" prop="receiptor">
        <el-select v-model="ruleForm.receiptor" placeholder="请选择">
          <el-option label="本人领取" value="1"></el-option>
          <el-option label="其他自然人领取" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="公证员：" prop="notaryPeople">
        <el-input v-model="ruleForm.notaryPeople" disabled placeholder="公证员"></el-input>
        <!-- <el-select v-model="ruleForm.notaryPeople" placeholder="请选择">
          <el-option v-for="item in OfficeUserList" :key="item.name" :label="item.name" :value="item.id"></el-option>
          
          <el-option label="系统自动分配" value="0"></el-option>
        </el-select> -->
      </el-form-item>
      <el-form-item label="补充资料：" prop="fileList" class="marker_w">
        <el-upload
            :disabled="fileList.length >= 18"
            class="upload-demo"
            ref="uploadFiles"
            action="/notaryApply/uploadNotaryApplyFile"
            multiple="true"
            :show-file-list="false"
            :on-error="errorUpload"
            :before-upload="beforeUpload"
            :on-success="handleChange"
            :headers="uploadHeader()"
        >
          <el-button size="small" type="primary" class="fileUpload"></el-button>
          <div slot="tip" class="el-upload__tip">最多可上传18份补充资料，格式不限，每份文件不得超过200M</div>
        </el-upload>
        <p v-if="fileList.length >= 18" style="color: #FF0000">超出限制数量，无法上传！</p>
        <div class="file-list-box">
          <div class="file-list-modal" v-if="fileLoadingNum"></div>
          <div v-for="(item, index) of fileList" :key="index" class="el-upload-list__item">
            <a class="el-upload-list__item-name">
              <div class="file-info-left">
                <i class="el-icon-document"></i>
                <div class="file-name-block">
                  <p>{{ item.name }}</p>
                  <span class="success" v-if="item.state == 'ok'">上传成功</span>
                  <span class="wait" v-if="item.state == 'wait'">等待上传</span>
                  <span class="error" v-if="item.state == 'failed'">上传失败</span>
                  <span class="error" v-if="item.state == 'exceed'">上传失败，文件大小超限</span>
                </div>
              </div>
              <span class="file-size">{{ item ? item.fileSize : '' }}</span>
            </a>
            <i class="el-icon-close" @click="removeFile(index)"></i>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="备注：" prop="marker" class="marker_w">
        <el-input v-model="ruleForm.marker"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="cancelFn">取消</el-button>
        <el-button @click="resetForm()" style="display:none">重置</el-button>
        <el-button type="primary" :disabled="isSubmitIng || fileLoadingNum" @click="submitForm('ruleForm')">确定
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import BaseApi from "@lib/baseApi.js";
import Util from "@lib/util";

export default {
  props: {
    checkExecutionInfo: {
      type: Object,
      defaule: {}
    },
    taskType: {
      type: Number,
      defaule: 0
    }
  },
  data() {
    var marker = (rule, value, callback) => {
      if (value.length > 31) {
        callback(new Error("长度不超过30个字符"));
      } else {
        callback();
      }
    };
    return {
      isSubmitIng: false,
      notClick: true,
      listData: [],
      NotaryUser: [],
      id: [],
      type: 1,
      num: 0,
      documentsNum: 1,
      ruleForm: {
        name: "",
        // notarization: "",
        notaryPeople: "",
        receiptor: "",
        // location: "",
        marker: ""
      },
      OfficeUserList: [],//公证员
      rules: {
        name: [
          {required: true, message: "请输入要公证合同名称", trigger: "blur"}
        ],
        marker: [
          {required: false, message: "请输入备注", trigger: "blur"},
          {validator: marker, trigger: "blur"}
        ],
        notarization: [
          {required: true, message: "请选择公证处", trigger: "blur"}
        ],
        receiptor: [
          {required: true, message: "请选择领取人", trigger: "blur"}
        ],
        // notaryPeople:[
        //   { required: true, message: "请选择公证员", trigger: "blur" }
        // ],
        location: [
          {required: true, message: "请选择公证所在地", trigger: "blur"}
        ]
      },
      /* 补充资料上传start */
      fileList: [], // 补充资料列表
      isOverflow: false, // 是否超个数
      fileLoadingNum: 0, // 正在上传数量
      /* 补充资料上传end */
    };
  },
  methods: {
    /* 补充资料上传start */
    uploadHeader() {
      return {
        token: localStorage.token || "mVYUzIuJCAmoOjgiI0xaaW8mfqJGPq",
        "X-CSRF-Token": sessionStorage.token,
        "request-id": Util.getUID()
      };
    },
    beforeUpload(file) {
      file.state = 'wait';
      this.fileLoadingNum++;
      if (this.fileList.length < 18) {
        this.fileList.unshift(file);
      } else {
        this.isOverflow = true;
        this.fileLoadingNum--;
        return false;
      }
    },
    errorUpload(err, file, fileList) {
      console.log(err, file)
    },
    handleChange(res, file) {
      this.fileLoadingNum--;
      const fileSize = Number(file.size / 1024 / 1024);
      if (fileSize > 1) {
        file.raw.fileSize = fileSize.toFixed(2) + 'M'
      } else {
        file.raw.fileSize = (fileSize * 1024).toFixed(2) + 'kb'
      }
      if (res.code == '5001') { // 超过200M
        file.raw.state = 'exceed';
      } else { // 上传成功
        file.raw.state = 'ok';
        file.raw.filePath = res.datas.filePath;
      }
      const sameIndex = this.fileList.findIndex(item => {
        return item.filePath == file.raw.filePath
      })
      this.$set(this.fileList, sameIndex, file.raw)
    },
    removeFile(index) {
      this.fileList.splice(index, 1);
      if (this.fileList.length < 4) {
        this.isOverflow = false;
      }
    },
    /* 补充资料上传end */
    submitForm(formName) {
      this.isSubmitIng = true;
      var newLocation = {};
      this.$refs[formName].validate(valid => {
        if (valid) {
          // if(this.NotaryUser && this.listData){
          // this.ruleForm.notarization=this.NotaryUser.filter(item=>item.notaryCode==this.ruleForm.notarization)[0]
          // this.ruleForm.notarization= this.listData.filter(item=>item.code== this.ruleForm.notarization)[0]
          //  if (this.ruleForm.notarization == 110000) {
          //   this.ruleForm.notarization = "北京";
          // } else if(this.ruleForm.notarization == 130000) {
          //   this.ruleForm.notarization = "河北";
          // }else if(this.ruleForm.notarization == 330000){
          //   this.ruleForm.notarization = "浙江";
          // }else{
          //   this.ruleForm.notarization = "北京";
          // }
          // this.ruleForm.notarization=
          //  newLocation=this.listData.filter(item=>item.id== this.ruleForm.location)[0]
          //  }
          let filePathList = [];
          if (this.fileList.length) {
            this.fileList.forEach(item => {
              if (item.filePath) {
                filePathList.push(item.filePath)
              } else {
                this.$message.error('附件文件状态异常，请检查!');
                this.isSubmitIng = false;
              }
            })
          }

          var params = {
            notarizationName: this.ruleForm.name,
            evidenceCount: this.checkExecutionInfo.count,
            // notaryId: this.ruleForm.location,
            // notarial: "",
            // location: newLocation.addres,
            // location: this.ruleForm.notarization.province,
            recipientType: this.ruleForm.receiptor,
            contractPerformTaskId: this.checkExecutionInfo.contractPerformId,
            // contractIds: this.id,
            remarks: this.ruleForm.marker,
            notarizationType: 4,
            applyFilePathList: filePathList,
            notaryBusinessId: this.taskType == '4' ? '4' : '',
            // type: this.type
          };
          // for (var i = 0; i < this.listData.length; i++) {
          //   if (this.listData[i].id == params.notaryId) {
          //     params.notarial = this.listData[i].name;
          //   }
          // }
          BaseApi.createRpcToken("/notaryApply/addNotaryApply", params, "post")
              .then(
                  data => {
                    this.notClick = false;
                    setTimeout(() => {
                      this.notClick = true;
                    });
                    if (data.code == "3706") {
                      this.$emit("closeDialog", false);
                      this.$emit("hintMessage", true);
                      this.resetForm();
                      setTimeout(() => {
                        this.$emit("hintMessage", false);
                        this.$emit("applyNotar", true);
                        this.isSubmitIng = false;
                      }, 2000);
                      return;
                    }
                    if (data.code == 5001) {
                      this.isSubmitIng = false;
                      this.$message.error("系统繁忙");
                      return;
                    }
                    if (data.datas.id) {
                      this.resetForm();
                      this.$emit("closeDialog", false);
                      this.$emit("successMessageFn", true);
                      setTimeout(() => {
                        this.$emit("closeHints", true);
                        this.$router.replace({
                          path: "/personal/serviceHome/writeProcedure", query: {
                            fromType: 4,
                            notaryApplyId: data.datas.id,
                            notaryBusinessId: this.taskType == '4' ? '8' : '4'
                          }
                        });
                        this.isSubmitIng = false;
                      });
                      localStorage.removeItem("xinxi");
                      sessionStorage.setItem("xinxi", JSON.stringify(data.datas));
                    } else {
                      this.isSubmitIng = false;
                      this.$message.error("申请强执公证失败！");
                      this.resetForm();
                      this.num = 0;
                      this.$emit("hintMessage", false);
                    }
                  },
                  data => {
                    this.isSubmitIng = false;
                  }
              )
              .catch(function (e) {
                errorLog(e);
              });
        } else {
          this.isSubmitIng = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
      this.$refs.uploadFiles.clearFiles();
      this.fileList = [];
    },
    cancelFn() {
      this.$emit("closeDialog", false);
      this.resetForm();
    },
    linkageFn() {
      var params = {
        notaryCode: this.ruleForm.notarization
      };
      BaseApi.createRpcToken("/Judiciary/findNotarization", params, "get")
          .then(
              data => {
                this.listData = data.datas.lits;
                this.ruleForm.location = data.datas.lits[0].id;
              },
              data => {
              }
          )
          .catch(function (e) {
            errorLog(e);
          });
    },
    setData(arr) {
      this.id = arr;
      this.num = this.id.length;
    }
  },
  created() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let userArr = [...[userInfo.person], ...userInfo.enterpriseList];
    let curInfo = userArr.filter(item => item.userId == userInfo.currentUserId)[0];
    this.type = curInfo.realNameType
    this.ruleForm.notaryPeople = this.checkExecutionInfo.internalNotaryName;//公证员名称
    // this.init();
  }
};
</script>
<style lang="scss">
.applyNoatr {
  .el-form {
    // padding:0px 30px;
    box-sizing: border-box;
    display: table;

    .el-form-item {
      float: left;
      width: calc(95% / 2);

      .el-form-item__label {
        font-size: 14px;
        color: #1E1E1E;
        line-height: 30px;
        padding: 0;
        width: 100px !important;
      }

      .el-form-item__label:before {
        content: "" !important;
        margin: 0 !important;
      }

      .el-form-item__content {
        position: relative;
        line-height: 30px;
        margin-left: 100px !important;

        .el-input {
          .el-input__inner {
            width: 168px;
            height: 30px;
            border-radius: 0;
            line-height: 30px;
            padding-left: 10px;
            color: #606266;
          }

          .el-input__icon {
            line-height: 30px;
          }

          .el-input__inner::placeholder {
            font-size: 14px;
          }
        }
      }

      .el-button {
        width: 100px;
        height: 30px;
        border: 1px solid #db4437;
        line-height: 30px;
        padding: 0;
        border-radius: 0;
        background-color: #fff;
        font-size: 14px;
        color: #646464;
        margin-left: 67px;
      }

      .el-button.is-disabled,
      .el-button.is-disabled:focus,
      .el-button.is-disabled:hover {
        cursor: not-allowed;
        background-image: none;
        background: rgb(220, 220, 220);
        border-color: #ebeef5;
      }
    }

    .marker_w {
      width: 91%;

      .el-input__inner {
        width: 92% !important;
      }
    }

    .el-form-item:nth-child(2n-1),
    .el-form-item:nth-child(8) {
      margin-right: 10px;
      margin-left: 20px;
    }

    // .el-form-item:nth-child(6) {
    //   width: 100%;
    //   .el-input__inner {
    //     width: 100% !important;
    //   }
    // }
    .el-form-item:nth-child(2) {
      padding-left: 0px;
      box-sizing: border-box;
    }

    .el-form-item:last-child {
      width: 100% !important;

      .el-button--primary {
        color: #db4437;
        margin-right: 100px;
        margin-left: 90px;
      }

      .el-button--primary:hover {
        color: #fff;
        border-color: #a5303d;
        background-color: #a5303d;
      }

      .el-button:first-child {
        border: 1px solid #c8c8c8;
      }

      .el-button:first-child:hover {
        color: #db4437;
        border-color: #db4437;
      }
    }
  }

  .notarization-desc-titile {
    width: 100%;
    text-align: center;
    height: 40px;
    line-height: 40px;
    background: #F6E0E2;
    color: #C76169;
    font-size: 14px;
  }

  .notarization-title {
    width: 100%;
    height: 46px;
    background-color: #F6F6F6;
    text-align: center;
    line-height: 46px;
    color: #464646;
    margin-bottom: 20px;

    h3 {
      font-weight: normal;
      font-size: 14px;
    }
  }
}

.fileUpload {
  margin-left: 0 !important;
  background: url("~@image/executionApplyNotar/upload.png");
  background-size: 100%;
  border: 0 !important;
  width: 96px !important;
  height: 36px !important;

  &:hover {
    background: url("~@image/executionApplyNotar/upload-hover.png");
    background-size: 100%;
  }

  &:active {
    background: url("~@image/executionApplyNotar/upload-active.png");
    background-size: 100%;
  }

  &:focus {
    background: url("~@image/executionApplyNotar/upload.png");
    background-size: 100%;
  }
}

.el-upload__tip {
  display: inline-block;
  line-height: 36px;
  margin-top: 0px;
  vertical-align: top;
  height: 36px;
  color: #646464;
  font-weight: 400;
  padding-left: 6px;
}

.file-list-box {
  max-height: 144px;
  overflow-y: auto;

  .file-list-modal {
    height: 100%;
    position: absolute;
    background: rgba(255, 255, 255, 0.6);
    width: 100%;
    z-index: 999;
  }
}

.el-upload-list__item {
  line-height: normal;
  padding: 4px 0;

  .file-list-modal {
    height: 100%;
  }

  &:hover {
    background-color: #FAFAFA;

    .el-icon-close {
      background: url("~@image/executionApplyNotar/close-hover.png");
      background-size: 100%;
    }
  }

  .el-icon-close {
    background: url("~@image/executionApplyNotar/close.png");
    background-size: 100%;
    top: 10px;
    display: block;
  }

  .el-upload-list__item-name {
    display: flex;
    align-items: flex-start;
    color: #000000;
    padding-left: 0;
    justify-content: space-between;

    .file-info-left {
      display: flex;
      align-items: center;
    }

    .file-size {
      font-weight: 400;
      color: #8B8B8B;
      font-size: 12px;
    }

    .el-icon-document {
      background: url("~@image/executionApplyNotar/file-icon.png");
      background-size: 100%;
      width: 22px;
      height: 26px !important;

      &::before {
        content: '';
      }
    }

    .file-name-block {
      font-weight: 400;
      color: #000000;
      font-size: 12px;
      line-height: 12px;

      span {
        font-weight: 400;
        color: #3CB600;
        line-height: 10px;
        font-size: 10px;
        margin-top: 4px;
        display: inline-block;

        &.success {
          color: #3CB600;
        }

        &.wait {
          color: #F79717;
        }

        &.error {
          color: #FF0000;
        }
      }

      p {
        max-width: 332px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}

</style>

